'use client';

import { useMergeRefs } from '@floating-ui/react';
import { ReactNode, Ref } from 'react';
import { sprinkles } from '../sprinkles.css';
import { useDropdownContext } from './useDropdownContext';

interface DropdownTriggerProps {
  children: ReactNode;
  ref?: Ref<HTMLElement>;
  className?: string;
}

export const DropdownTrigger = ({
  children,
  ref: forwardedRef,
  className,
  ...props
}: DropdownTriggerProps) => {
  const { open, refs, getReferenceProps } = useDropdownContext();
  const ref = useMergeRefs([refs.setReference, forwardedRef]);
  const dataState = open ? 'open' : 'closed';

  return (
    <div
      className={className ?? sprinkles({ display: 'inline-flex' })}
      ref={ref}
      data-state={dataState}
      {...getReferenceProps({ ...props, onClick: e => e.stopPropagation() })}>
      {children}
    </div>
  );
};
